// extracted by mini-css-extract-plugin
export var cardHeader = "_gx-0";
export var reorderHandle = "_gx-3";
export var titleArea = "_gx-1";
export var titleAreaWithHandle = "_gx-2";